module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": "Migração de produtos",
      "listLogo": _vm.moduleDefinition.logo,
      "filterTitle": "Filtros",
      "loading": _vm.loading,
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'asc'
      },
      "total": _vm.productsMigrationTotal
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('template', {
    slot: "filters"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Código do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.sku),
      expression: "options.sku"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "sku", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Título do produto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.title),
      expression: "options.title"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status de Migração"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.status),
      expression: "options.status"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.migration.status), function(status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.migration." + status + ".label"))))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Status do Produto no Marketplace"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.active),
      expression: "options.active"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.productMarketplaceActive.status), function(status) {
    return _c('option', {
      domProps: {
        "value": status
      }
    }, [_vm._v(_vm._s(_vm.$t(("migration.statusProductMarketplace." + status + ".label"))))])
  })], 2)])], 1)])]), _vm._v(" "), (_vm.productsMigration.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.productsMigration), function(productMigration) {
    return _c('product-migration-card', {
      key: productMigration,
      attrs: {
        "module": _vm.module,
        "modules": _vm.modules,
        "product": productMigration
      }
    })
  }), 1) : _c('div', {
    staticClass: "l-col-12@md u-textCenter"
  }, [_c('panel', [_vm._v("Nenhum produto encontrado.")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-181963e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductMigration/Cnova.vue
// module id = 2943
// module chunks = 0